var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-reference-text"},[_vm._v(" Вже маєте акаунт? "),_c('a',{staticClass:"login-reference-text_ref",attrs:{"href":"/auth/login"}},[_vm._v("Увійти")])])
}]

export { render, staticRenderFns }